export enum WebFlowAction {

  // Start PaymentOptions PassengersForm Components
  SEND_REQUEST_CONFIRMATION_EMAIL_START = 'SEND_REQUEST_CONFIRMATION_EMAIL_START',
  SEND_REQUEST_CONFIRMATION_EMAIL_SUCCESS = 'SEND_REQUEST_CONFIRMATION_EMAIL_SUCCESS',
  SEND_REQUEST_CONFIRMATION_EMAIL_ERROR = 'SEND_REQUEST_CONFIRMATION_EMAIL_ERROR',
  SEND_REQUEST_CONFIRMATION_EMAIL_FAILED = 'SEND_REQUEST_CONFIRMATION_EMAIL_FAILED',
  // End PaymentOptions  PassengersForm Components

  // Start PaymentOptions
  EXECUTING_PAYMENT_START = 'EXECUTING_PAYMENT_START',
  EXECUTING_PAYMENT_SUCCESS = 'EXECUTING_PAYMENT_SUCCESS',
  EXECUTING_PAYMENT_ERROR = 'EXECUTING_PAYMENT_ERROR',
  EXECUTING_PAYMENT_CANCEL = 'EXECUTING_PAYMENT_CANCEL',
  EXECUTING_PAYMENT_FAILED = 'EXECUTING_PAYMENT_FAILED',
  EXECUTING_PAYMENT_BLOCK_DEPARTURE_FAILED = 'EXECUTING_PAYMENT_BLOCK_DEPARTURE_FAILED',

  START_ON_HOLD = 'START_ON_HOLD',
  ON_HOLD = 'ON_HOLD',
  CLICK_TERMS_CONDITIONS = 'CLICK_TERMS_CONDITIONS',

  SENDING_AUTOMATIC_LESS_72H_SUCCESS = 'SENDING_AUTOMATIC_LESS_72H_SUCCESS',
  SENDING_AUTOMATIC_LESS_72H_FAILED = 'SENDING_AUTOMATIC_LESS_72H_FAILED',

  //End Payment Options

  //Start Package Component
  SELECTED_PACKAGE_ = 'SELECTED_PACKAGE_',
  //End Package Component

  //Start Searcher Component
  SEARCH = 'SEARCH',
  //End Seacher Component

  //Start by-cruise Component
  SELECT_ITINERARY = 'SELECT_ITINERARY',
  //End by-cruise Component

  //Start Cabins Component
  SELECTED_CABINS = 'SELECTED_CABINS',
  //End Cabins Component

  //Start Passenger Component
  SELECTED_BED_ = 'SELECTED_BED_',
  //End Passenger Component

  //Start Passenger Form Component
  ENTERING_PASSENGER_DATA = 'ENTERING_PASSENGER_DATA',
  FILL_PASSENGER_FORM = 'FILL_PASSENGER_FORM',
  MAIN_CONTACT_PERSON_EMAIL = 'MAIN_CONTACT_PERSON_EMAIL',
  //End Passenger Form Component

  //Start FormContactUs Component
  INPUT_CONTACT_FORM_DATA = 'INPUT_CONTACT_FORM_DATA',
  //End FormContactUs Component

  // todo no estan siendo usados, DEDBERIAN SER EN el inquiere apesar de que usa un servicio  diferente ???
  // Se estan usando en el inquire charter y en contact us!
  //Start Forms Inquire
  INQUIRE_AVAILABILITY_START = 'INQUIRE_AVAILABILITY_START',
  INQUIRE_AVAILABILITY_COMPLETED = 'INQUIRE_AVAILABILITY_COMPLETED',
  INQUIRE_ERROR = 'INQUIRE_ERROR',
  //End Forms Inquire

  //Start PassengersForm Cabins  Passenger SelectionTourSummary Components
  GO_BACK_ = 'GO_BACK_',
  //End PassengersForm Cabins  Passenger SelectionTourSummary Components

  //Start Credit CardApi Component
  REQUEST_CREDITCARD_PAYMENT_ERROR = 'REQUEST_CREDITCARD_PAYMENT_ERROR',
  //End Credit CardApi Component

  MODAL_ITINERARY_OPEN = 'MODAL_ITINERARY_OPEN',
  MODAL_ITINERARY_CLOSE = 'MODAL_ITINERARY_CLOSE',

  //Start ContactForm Service
  INQUIRE_CRM_START = 'INQUIRE_CRM_START',
  INQUIRE_CRM_COMPLETED = 'INQUIRE_CRM_COMPLETED',
  INQUIRE_CRM_ERROR = 'INQUIRE_CRM_ERROR',
  //End ContactForm Service

  //Start FormContactUs Components
  SENDING_FORM_COMPARE_SUCCESS = 'SENDING_FORM_COMPARE_SUCCESS',
  SENDING_FORM_COMPARE_FAILED = 'SENDING_FORM_COMPARE_FAILED',
  //End FormContactUs Components

  //Start Selection Step , Forms Inquire Components
  SHARED_WITH_ = 'SHARED_WITH_',
  //End Selection Step , Forms Inquire Components

  //Start Cruise Info Component
  NAV_CRUISE_INFO_   = "NAV_CRUISE_INFO_",
  //End Cruise Info Component

  //TODO: no usados por el momento
  SELECT_ITINERARY_FROM_DETAILS= "SELECT_ITINERARY_FROM_DETAILS",
  SELECT_ITINERARY_FROM_ITINERARY= 'SELECT_ITINERARY_FROM_ITINERARY',
  DETAILS = "DETAILS",

  //Auditoria de la navegacion de orgien de wishlist y compare
WISHLIST = 'WISHLIST',
COMPARE = 'COMPARE',

BOOKING_START = 'BOOKING_START',
BOOKING_REQUEST_START = 'BOOKING_REQUEST_START',
BOOKING_COMPLETED = 'BOOKING_COMPLETED',
BOOKING_FAILED = 'BOOKING_FAILED',

EXECUTING_PAYMENT_STRIPE_START = 'EXECUTING_PAYMENT_STRIPE_START',
EXECUTING_PAYMENT_STRIPE_SUCCESS = 'EXECUTING_PAYMENT_STRIPE_SUCCESS',
EXECUTING_PAYMENT_STRIPE_ERROR = 'EXECUTING_PAYMENT_STRIPE_ERROR',
EXECUTING_PAYMENT_STRIPE_FAILED = 'EXECUTING_PAYMENT_STRIPE_FAILED',
EXECUTING_PAYMENT_BLOCK_ERROR ='EXECUTING_PAYMENT_BLOCK_ERROR',

EXECUTING_PAYMENT_WETRAVEL_START = 'EXECUTING_PAYMENT_WETRAVEL_START',
EXECUTING_PAYMENT_WETRAVEL_SUCCESS = 'EXECUTING_PAYMENT_WETRAVEL_SUCCESS',
EXECUTING_PAYMENT_WETRAVEL_ERROR = 'EXECUTING_PAYMENT_WETRAVEL_ERROR',

}
